import React from 'react';
import useBundleTranslation from 'i18n';
import { Popup } from 'components/common/popup/Popup';
import { Box } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import { Stack } from '@mui/system';
import { useSelector } from 'react-redux';

interface WarnMismatchLoginPopupProps {
    onHide: () => void;
}
export function WarnMismatchLoginPopup(props: WarnMismatchLoginPopupProps) {
    const { t } = useBundleTranslation(['components/common/warn_mismatch_login_popup']);
    const supportAdmins = useSelector((state: any) => state.auth?.userInfo?.supportAdmins) ?? [];
    const miUserName = useSelector((state: any) => state.auth?.userInfo?.username) ?? '';
    const usernameLoggedInSamlAsMi = useSelector((state: any) => state.auth?.userInfo?.usernameLoggedInSamlAsMi) ?? '';

    return (
        <Popup
            maxWidth={'popupMd'}
            open={true}
            settings={{
                textOK: t('btn_ok'),
                noCancel: true,
                customMaxWidth: '527px',
            }}
            onHide={null}
            onConfirm={() => {
                props.onHide();
            }}
        >
            <Stack direction={'row'}>
                <Box sx={{ fontSize: '16px', mr: 1, color: 'warning.main' }}>
                    <IconMi icon={'error'} />
                </Box>
                <Stack spacing={2}>
                    <Box>
                        {t('mismatch_message', {
                            usernameLoggedInSamlAsMi: usernameLoggedInSamlAsMi,
                            usernameMi: miUserName,
                        })}{' '}
                        <Box component={'span'} sx={{ fontWeight: 600 }}>
                            {t('report_message')}
                        </Box>
                    </Box>
                    <Box>{t('note_message')}</Box>
                    {supportAdmins.length > 0 && (
                        <Box>
                            <Box sx={{ pb: 1.5 }}>{t('system_admins_label')}:</Box>
                            <Stack spacing={0.5}>
                                {supportAdmins.map((user: any) => {
                                    return (
                                        <Stack sx={{ color: 'primary.main' }} direction="row" key={user.username}>
                                            <Box
                                                sx={{
                                                    display: 'inline-flex',
                                                    mr: 1,
                                                    mt: '1px',
                                                    fontSize: '16px',
                                                    width: '16px',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <IconMi icon={'user-profile'} />
                                            </Box>
                                            <Box>{user.display_name}</Box>
                                        </Stack>
                                    );
                                })}
                            </Stack>
                        </Box>
                    )}
                </Stack>
            </Stack>
        </Popup>
    );
}
